module.exports = __webpack_public_path__ + "static/media/Asian.a1e9c650.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Asian.png
// module id = 1330
// module chunks = 3